export const REACT_FULLPAGE_LICENSE_KEY = '8C7E2F99-2619466F-8914E77E-85A07B8F';